import { Image, type ImageProps } from '@mantine/core';
import styles from './CheeseIcon.module.css';

export type CheeseIconProps = ImageProps & {
  withAnimation?: boolean;
  'data-test-id'?: string;
};

export const CheeseIcon = ({
  withAnimation = true,
  w = 32,
  h = 32,
  'data-test-id': dataTestId,
  ...props
}: CheeseIconProps) => {
  return (
    <Image
      alt="cheese"
      className={styles['cheese-icon']}
      data-animated={withAnimation}
      data-test-id={dataTestId}
      fit="contain"
      h={h}
      src="/icons/cheese.webp"
      style={{
        userSelect: 'none',
      }}
      w={w}
      {...props}
    />
  );
};
